import {
  useAuthStateQuery,
  useGetMembershipsQuery
} from 'generated/graphql';

import {
  Navigate,
  Outlet
} from 'react-router-dom';



export type PrivateRouteProps = {
  extraAuthNavState?: unknown;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PrivateRouteProps) => {
  const queryTuple = useAuthStateQuery();
  useGetMembershipsQuery();

  console.log('Private Route Rendered');

  if (queryTuple.data?.authQuery?.authStatus === 'signedIn') {
    return <Outlet />;
  }

  return (
    <Navigate
      to='/auth/login'
      replace
      state={props.extraAuthNavState}
    />
  );
};
